import React, { useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import supabase from "../lib/supabaseClient";
import "./login.css";

const Login = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // where OAuth returns to (keep if you’re using Google)
  const redirectTo = useMemo(() => {
    return `${window.location.origin}/auth/callback`;
  }, []);

  const signInWithEmail = async (e) => {
    e.preventDefault();
    setErr("");
    setMsg("");
    setLoading(true);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    setLoading(false);

    if (error) {
      setErr(error.message);
      return;
    }

    // ✅ logged in
    if (data?.session) {
      history.push("/dashboard");
      return;
    }

    // edge case
    setErr("Login succeeded but no session was returned.");
  };

  const signInWithGoogle = async () => {
    setErr("");
    setMsg("");
    setLoading(true);

    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo },
    });

    // Supabase redirects away; this is just for errors
    if (error) {
      setLoading(false);
      setErr(error.message);
    }
  };

  return (
    <div className="login-container">
      <Helmet>
        <title>Login - Sylliplan</title>
      </Helmet>

      {/* IMPORTANT: your inputs must be inside this form */}
      <form className="login-card" onSubmit={signInWithEmail}>
        {/* ...your existing UI... */}

        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="name@university.edu"
          type="email"
          required
        />

        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          type="password"
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Processing..." : "Sign In"}
        </button>

        <button type="button" onClick={signInWithGoogle} disabled={loading}>
          Continue with Google
        </button>

        {err ? <div className="login-error">{err}</div> : null}
        {msg ? <div className="login-msg">{msg}</div> : null}
      </form>
    </div>
  );
};

export default Login;
